import React, { FC }            from "react";
import { useDispatch }          from "react-redux";
import { Card, Checkbox, Form } from "semantic-ui-react";
import CustomerRecordRepository from "../../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecordWidget     from "../../../../../domain/record/customer/widget/CustomerRecordWidget";
import CustomerRecordWidgetItem from "../../../../../domain/record/customer/widget/item/CustomerRecordWidgetItem";
import WidgetItemValue          from "../../../../../domain/record/widget/item/WidgetItemValue";
import CustomerRecordDataSource
                                from "../../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";

interface Props {
  widgetIndex: number;
  widget: CustomerRecordWidget;
}

const CheckHorizontalWidget: FC<Props> = (props: Props) => {
  const {widgetIndex, widget} = props;
  const repository: CustomerRecordRepository = new CustomerRecordDataSource(useDispatch());
  const calcNextWidth = (widget: CustomerRecordWidget): number => {
    let nextWidth: number = 0;
    widget.items.toList().forEach((_, index) => {
      if (index > 0) {
        nextWidth += 290;
      }
    });
    return nextWidth;
  };
  return (
    <>
      <div
        style={ {
          position: "absolute",
          left: `${ widget.coordinate.x }px`,
          top: `${ widget.coordinate.y }px`
        } }
        key={ widgetIndex }
      >
        <Card style={ {width: `${ 318 + calcNextWidth(widget) }px`} }>
          <Card.Content>
            <Form>
              <Form.Field>
                <label>{ widget.title.value }</label>
              </Form.Field>
              {
                widget.items.toList().map((widgetItem, widgetItemIndex) => (
                  <Checkbox
                    name={ widget.id.toString() }
                    label={ widgetItem.title.value }
                    checked={ widgetItem.value.value === "select" }
                    style={ {width: "242px"} }
                    onClick={ () => repository.setCustomerRecordWidgetItem(widgetIndex, widgetItemIndex, new CustomerRecordWidgetItem(widgetItem.id, widgetItem.widgetItemId, widgetItem.title, new WidgetItemValue("select"))) }
                  />
                ))
              }
            </Form>
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default CheckHorizontalWidget;
